module.exports = __webpack_public_path__ + "media/images/sync-icon-display-ada746d170e868f78e6cfc9e9522a96d.svg";